import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Resource } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_RESOURCE_BY_ID = 'get-resource-by-id';

export const useGetResourceById = (id: number) => {
  return usePermittedQuery<Resource>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/resource/${id}`,
    {},
    [GET_RESOURCE_BY_ID],
    {
      enabled: typeof id === 'number' && id >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
